import { Injectable } from '@angular/core';
import { MapControlService } from './map-control.service';
import { CommonService } from './common.service';
import { forkJoin } from 'rxjs';
import { combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventLogicService {
  milestonesData: any;
  tripData: any;
  healthLogs: any;
  healthLogsBetTrip: any;
  prevHealthLogs: any;

  stoppageIntervals: any[] = [];
  deviceOffIntervals: any[] = [];
  gpsLossIntervals: any[];
  noNetworkRanges: any[] = [];
  sosTimeLoc: any[];
  seatBeltLoc:any[];
  overspeedingIntervals: any[] = [];
  driverOffData: any[]=[];
  tripMetaData: any;
  seatBeltData:any[] = []
  vehicleArrivedData:any;
  seatBeltIntervals:any[] = []
  vehicleArrivedIntervals:any[] = []
  constructor(
    private mapControlService: MapControlService,
    private commonService: CommonService
  ) {
    this.tripData = this.commonService.response['tripDetails'];
    this.commonService.locationListRes.subscribe((res) => {
      const length = res.length
      this.milestonesData = res.slice(this.commonService.outOfRangeLowerBound, res.length - this.commonService.outOfRangeUpperBound)
    });
    this.commonService.healthLogRes.subscribe((res) => {
      if (res) {
        this.healthLogs = res;
      }
    });
    this.commonService.driverOffData$.subscribe((res) => {  
      if(res){
        try{
          this.driverOffData= res["eventMap"]["DEVICE_INACTIVE"];
        }catch(e){
          console.log('some error occured')
        }
      }
    });
    this.commonService.tripMetaData$.subscribe((res) => {
      if(res){
        this.tripMetaData = res ?? []
      }
     });

    this.commonService.deviceEventsData$.subscribe((res) => {
      if(res && res['eventMap']){
        try{
          this.seatBeltData = res['eventMap']['DRIVER_SEAT_BELT_EVENT'] ?? []
          this.vehicleArrivedData = res['eventMap']['VEHICLE_ARRIVED'] ?? []
        }catch(e){
          this.seatBeltData = []
          this.vehicleArrivedData = []
        }
      }
    })
    // Previous date device health
    // this.commonService.prevHealthLogRes.subscribe((res) => {
    //   if (res) {
    //     this.prevHealthLogs = res;
    //   }
    // });

    this.healthLogsBetTrip = this.healthLogs.filter(
      (log) =>
        log.recordedTime >= this.tripData.actualStartTime &&
        log.recordedTime <= this.tripData.actualEndTime
    );

    //Logics

    // Vehicle Stoppage

    // < 10 m for >10 min logic

    // for (let i = 0; i < this.milestonesData.length - 1; i++) {
    //   let clock = 0;
    //   const loc1 = new google.maps.LatLng(
    //     this.milestonesData[i].latitude,
    //     this.milestonesData[i].longitude
    //   );
    //   for (let j = i + 1; j < this.milestonesData.length; j++) {
    //     const loc2 = new google.maps.LatLng(
    //       this.milestonesData[j].latitude,
    //       this.milestonesData[j].longitude
    //     );
    //     if (this.mapControlService.getDistance(loc1, loc2) < 10) {
    //       // less than 10 m
    //       clock = this.milestonesData[j].time - this.milestonesData[i].time;
    //       if (clock > 10 * 60 * 1000) {
    //         // for more than 10 mins
    //         this.stoppageIntervals.push({
    //           index: i,
              
    //         });
    //         i = j;
    //         break;
    //       }
    //     } else {
    //       break;
    //     }
    //   }
    // }

    let stoppageLogs = this.tripMetaData['VEHICLESTOPPAGE'] ?? []
    for(let i=0;i<stoppageLogs.length;i++){
      const event = stoppageLogs[i];
      this.stoppageIntervals.push({
        startTime: event.startTimeStamp,
        endTime: event.endTimeStamp,
        status: event.status,
        alertSeverity: event.alertSeverity,
        thresholdValue: event.thresholdvalue,
        raisedFrom: event.raisedFrom
        
        });
    }

    // Seat Belt events
    for(let i =0 ; i < this.seatBeltData?.length;i++){
      const event = this.seatBeltData[i];
      const startTime = event.startTimeStamp;
      const endTime = event.endTimeStamp;
      const [lat,lang] = event.startGeoCord.split(",");
      const geoCords = new google.maps.LatLng(Number(lat),Number(lang));
      const seatBeltStatus = event?.metadata?.isSeatBeltWorn === 'true';
      this.seatBeltIntervals.push({
        startTime: startTime,
        endTime: endTime,
        geoCords: geoCords,
        seatBeltStatus: seatBeltStatus,
        stwId:event.metadata?.stwId
      })
    }

    // Vehicle Arrived events
    for(let i =0 ; i < this.vehicleArrivedData?.length;i++){
      const event = this.vehicleArrivedData[i];
      const startTime = event.startTimeStamp;
      const reachedButtonClickType = event.metadata?.reachedButtonClickType;
      const cabArrivedEventType = event.metadata?.cabArrivedEventType;
      const endTime = event.endTimeStamp;
      const [lat,lang] = event.startGeoCord.split(",");
      const geoCords = new google.maps.LatLng(Number(lat),Number(lang));
      this.vehicleArrivedIntervals.push({
        startTime: startTime,
        endTime: endTime,
        geoCords: geoCords,
        stwId:event.metadata?.stwId,
        reachedButtonClickType
      })
    }

    // Device Off 
    for (let i = 0; i < this.driverOffData?.length; i++) {
      const event = this.driverOffData[i];
      const startTime = event.startTimeStamp;
      const endTime = event.endTimeStamp;
      const totalInactiveTimeInMins = Number(event.metadata.totalInactiveTimeInMins);
      this.deviceOffIntervals.push([startTime, endTime, startTime,totalInactiveTimeInMins]);
    }
    

    // GPS Loss
    let milestonesLoss = [];
    for (let i = 0; i < this.milestonesData.length - 1; i++) {
      if (
        Math.floor(
          (this.milestonesData[i + 1].time - this.milestonesData[i].time) / 1000
        ) >
        2 * 60 // 2 minutes
      ) {
        milestonesLoss.push([
          this.milestonesData[i],
          this.milestonesData[i + 1],
          Math.floor(
            (this.milestonesData[i + 1].time - this.milestonesData[i].time) /
              1000
          ),
        ]);
      }
    }
    console.log('milestonesLoss', milestonesLoss);
    this.gpsLossIntervals = milestonesLoss.filter((interval) => {
      let flag = true;

      this.getEvent('device-off').forEach((event) => {
        if (event[2] == interval[0].time) {
          flag = false;
        }
      });

      return flag;
    });

    // Network Loss
    const substr = 'failed to poll server';
    for (let i = 0; i < this.healthLogsBetTrip.length - 1; i++) {
      // Failed to poll server
      if (this.healthLogsBetTrip[i].event.toLowerCase().includes(substr)) {
        let j = i + 1;
        while (
          j < this.healthLogsBetTrip.length &&
          this.healthLogsBetTrip[j].event.toLowerCase().includes(substr)
        ) {
          j++;
        }
        j--;
        if (j - i >= 1) {
          this.noNetworkRanges.push([
            Number(this.healthLogsBetTrip[i].extraInfo.split(';')[10]),
            Number(this.healthLogsBetTrip[j].extraInfo.split(';')[10]),
            Math.floor(
              (Number(this.healthLogsBetTrip[j].extraInfo.split(';')[10]) -
                Number(this.healthLogsBetTrip[i].extraInfo.split(';')[10])) /
                1000
            ),
            'failed',
          ]);
          i = j + 1;
        }
        // And using device internet is enabled or disabled
      } else if (
        this.healthLogsBetTrip[i].event
          .toLowerCase()
          .includes('device internet is disabled')
      ) {
        let j = i + 1;
        while (
          j < this.healthLogsBetTrip.length &&
          !this.healthLogsBetTrip[j].event
            .toLowerCase()
            .includes('device internet is enabled')
        ) {
          j++;
        }
        if (
          j < this.healthLogsBetTrip.length &&
          this.healthLogsBetTrip[i].extraInfo.split(';')[10] != 0 &&
          this.healthLogsBetTrip[j].extraInfo.split(';')[10] != 0
        ) {
          this.noNetworkRanges.push([
            Number(this.healthLogsBetTrip[i].extraInfo.split(';')[10]),
            Number(this.healthLogsBetTrip[j].extraInfo.split(';')[10]),
            Math.floor(
              (Number(this.healthLogsBetTrip[j].extraInfo.split(';')[10]) -
                Number(this.healthLogsBetTrip[i].extraInfo.split(';')[10])) /
                1000
            ),
            'dis-en',
          ]);
          i = j + 1;
        }
      }
    }

    // Tripsheet
    // const str = '' + this.tripData.tripId;
    // let tripsheetDownload = this.prevHealthLogs.filter((log) => {
    //   return (
    //     log.event.toLowerCase().includes(str) &&
    //     log.event.toLowerCase().includes('type = 1901')
    //   );
    // });
    // // Not on previous day of trip, then
    // if (!tripsheetDownload.length) {
    //   tripsheetDownload = this.healthLogs.filter((log) => {
    //     return (
    //       log.event.toLowerCase().includes(str) &&
    //       log.event.toLowerCase().includes('type = 1901')
    //     );
    //   });
    // }
    // const tripSheetDisplayed = this.healthLogs.filter((log) => {
    //   return log.event.includes(
    //     `TripSheet displayed trip uuid = ${this.tripData.tripUuid}`
    //   );
    // });
    // if (tripsheetDownload.length) {
    //   console.log(
    //     tripsheetDownload.length,
    //     'Tripsheet Downloaded on',
    //     moment
    //       .utc(tripsheetDownload[0].recordedTime)
    //       .format('DD-MM-YYYY hh:mm a')
    //   );
    // }
    // if (tripSheetDisplayed.length) {
    //   console.log(
    //     tripSheetDisplayed.length,
    //     'Tripsheet Displayed at',
    //     moment
    //       .utc(tripSheetDisplayed[0].recordedTime)
    //       .format('DD-MM-YYYY hh:mm a')
    //   );
    // }

    // SOS
    let sosLogs = this.tripMetaData['SOS'] ?? []
    this.sosTimeLoc = sosLogs.map((sos) => {
      // Check if startgeocord is valid (not 'NA')
      if (sos.startgeocord === 'NA') return null;
      
      const [latitude, longitude] = sos.startgeocord.split(',');
      return {
        time: sos.startTimeStamp.toString(), // Convert timestamp to ISO string
        geocord: new google.maps.LatLng(latitude, longitude),
        startTime:sos.startTimeStamp,
        endTime:sos.endTimeStamp,
        status: sos.status,
        alertSeverity: sos.alertSeverity,
        thresholdvalue: sos.thresholdvalue,
        raisedFrom: sos.raisedFrom
      };
    }).filter(Boolean);

    console.log(this.sosTimeLoc);

    // Overspeeding
    // for (let i = 0; i < this.milestonesData.length - 1; i++) {
    //   if (
    //     this.milestonesData[i].mSpeed * 3.6 >
    //     this.mapControlService.thresholdSpeed
    //   ) {
    //     for (let j = i + 1; j < this.milestonesData.length; j++) {
    //       if (
    //         this.milestonesData[j].mSpeed * 3.6 <=
    //         this.mapControlService.thresholdSpeed
    //       ) {
    //         this.overspeedingIntervals.push([
    //           this.milestonesData[i].time,
    //           this.milestonesData[j].time,
    //         ]);
    //         i = j + 1;
    //         break;
    //       }
    //     }
    //   }
    // }
    let overspeedLogs = this.tripMetaData['OVERSPEEDING'] ?? []
    for(let i=0;i<overspeedLogs.length;i++){
      const event = overspeedLogs[i];
      this.overspeedingIntervals.push({
        startTime: event.startTimeStamp,
        endTime: event.endTimeStamp,
        status: event.status,
        alertSeverity: event.alertSeverity,
        thresholdValue: event.thresholdvalue,
        raisedFrom: event.raisedFrom
        });
    }

    console.log('Stop at ', this.getEvent('vehicle-stoppage'));
    console.log('Network Loss at ', this.getEvent('network-loss'));
    console.log('Device off at ', this.getEvent('device-off'));
    // this.getEvent('tripsheet');
    console.log('GPS Loss at', this.getEvent('gps-loss'));
    console.log('Overspeed at ', this.getEvent('overspeeding'));
  }

  getEvent(event: string) {
    switch (event) {
      case 'vehicle-stoppage': { 
        return this.stoppageIntervals ||[];
      }
      case 'device-off': {
        return this.deviceOffIntervals || [];
      }
      case 'gps-loss': {
        return this.gpsLossIntervals || [];
      }
      case 'network-loss': {
        return this.noNetworkRanges || [];
      }
      case 'tripsheet': {
        return [];
      }
      case 'sos': {
        return this.sosTimeLoc || [];
      }
      case 'overspeeding': {
        return this.overspeedingIntervals || [];
      }
      case 'seatBelt': {
        return this.seatBeltLoc || [];
      }
      case 'seat-belt': {
        return this.seatBeltIntervals;
      }
      case 'vehicle-arrived': {
        return this.vehicleArrivedIntervals;
      }
      default: {
        throw new Error('Invalid event type');
      }
    }
  }
}
